import { type CardRow } from 'components/framework/models';
import DraggableItem from 'javascripts/dnd/DraggableItem';

class DraggableDividerRow extends DraggableItem<CardRow> {}

export default DraggableDividerRow;
